<script setup lang="ts">
    const { accountBasePath } = useAccountBasePath();
    const { t } = useI18n();
    const bonus = useBonus();
</script>

<template>
    <li>
        <NuxtLink
            :to="`${accountBasePath}/bonus`"
            tabindex="-2"
            class="link"
            :aria-busy="bonus.isLoading.value"
        >
            <img
                class="icon"
                src="~/assets/icons/star.svg"
                alt=""
            />
            {{ t('account.bonus.title') }}
            <SimpleLoadingSpinner
                v-if="bonus.isLoading.value"
                :size="16"
                color="currentColor"
                role="progressbar"
                :aria-label="bonus.currentUsersPoints.unit"
            />
            <span v-else-if="bonus.currentUsersPoints.raw.value !== null">
                ({{ bonus.currentUsersPoints.formatted.value }})
            </span>
        </NuxtLink>
    </li>
</template>

<style lang="css" scoped>
    .link {
        background-color: var(--brand-secondary);
        color: var(--black);
        /* Arbitrary large value for pill shape */
        border-radius: 99px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 4px;
        padding-bottom: 4px;
        margin-left: -8px;
        margin-right: -8px;
    }
</style>
